import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Button } from '../../../subcomponents/button/button';
import { ButtonColor } from '../../../subcomponents/button/types/color';
import { OrderCartContextInstance } from '../types/context';
const b = bemClassBuilder('v-order-cart-section-divider');
export const OrderCartSectionDivider = observer(props => {
    const { title, actionButtonLabel, showActionButton, onActionButtonClicked } = props;
    const { config } = useContext(OrderCartContextInstance);
    return (_jsx("li", Object.assign({ className: b.block() }, { children: config.showLabels && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: b.element('title') }, { children: title })), showActionButton && (_jsx(Button, { color: ButtonColor.Tertiary, className: b.element('action-button'), onClick: onActionButtonClicked, label: actionButtonLabel }))] })) })));
});
OrderCartSectionDivider.displayName = 'OrderCartSectionDivider';
